import React from "react";
import PopupHeadIcons from "src/components/common/popup/PopupHeadIcons";
import IconButton from "src/components/common/icon-button/IconButton";
import CloseIcon from "src/components/common/icons/CloseIcon";
import { CardHeader, CardBody } from "reactstrap";
import { PopupCard } from "src/components/common/popup";
import AddDraftShiftForm from "./AddDraftShiftForm";
import { Moment } from "moment";

interface IProps {
  time: Moment;
  role?: string | null;
  id?: string;
  close: () => void;
}

// optimization so that this component only re-renders if
// props have changed
const areEqual = (prev: IProps, next: IProps) =>
  prev.time === next.time &&
  prev.role === next.role &&
  prev.id === next.id &&
  prev.close === next.close;

const styles = {
  popup: {
    width: "500px",
  },
};

const AddDraftShiftPopup: React.FC<IProps> = React.memo((props) => {
  const { time, id, role, close } = props;

  return (
    <PopupCard style={styles.popup}>
      <CardHeader>
        <h5>Add draft shift</h5>
        <PopupHeadIcons>
          <IconButton tooltip="Close" onClick={close} id="AddShiftPopupClose">
            <CloseIcon width={16} />
          </IconButton>
        </PopupHeadIcons>
      </CardHeader>
      <CardBody>
        <AddDraftShiftForm
          start={time}
          end={time.clone().add(8, "hours")}
          employeeId={id || ""}
          role={role || ""}
          handleClose={close}
        />
      </CardBody>
    </PopupCard>
  );
}, areEqual);

export default AddDraftShiftPopup;
